import {useEffect, useState} from 'react';

export const useUplusUserAgent = () => {
  const [isUplusApp, setIsUplusApp] = useState<boolean | null>(null);

  useEffect(() => {
    const ua = navigator.userAgent;
    const uplusRegex = /^(.*) lguplus-([^/]+)\/([^/]+)$/;
    const isUplusApp = uplusRegex.test(ua);

    setIsUplusApp(isUplusApp);
  }, []);

  return isUplusApp;
};
